module.exports = __webpack_public_path__ + "static/media/pig-grey.2e18d2fe.webp";